import GeoHelper from "../Helpers/GeoHelper";

const VesselGroupHelper = {
	toPathGeometry(vessels = [], filterFunction = null, pointAttach = null) {
		const allLines = [];
		const allPoints = [];
		vessels.forEach((vessel) => {
			if (vessel.visible && vessel.historicPath) {
				if (filterFunction === null || filterFunction(vessel)) {
					allLines.push(vessel.historicPath.line);
					if (pointAttach === null) {
						allPoints.push(...vessel.historicPath.points);
					}
					else {
						vessel.historicPath.points.forEach((point) => {
							allPoints.push(
								pointAttach(vessel, {
									...point,
									properties: {
										...point.properties
									}
								})
							);
						});
					}
				}
			}
		});
		return {
			lines: GeoHelper.emptyGeoJson(allLines),
			points: GeoHelper.emptyGeoJson(allPoints)
		};
	}
};
export default VesselGroupHelper;
